import type { EHorizontalPosition, ELineStyle, Widgets } from '@common/enums';
import type { FormControl, FormGroup } from '@angular/forms';

import type { SelectedFileExtended } from '@common/types/file.type';
import type { AnimationSettingsFormControls } from '@components/sp-animation-settings/type/animation-settings.type';
import type { WidgetPositionFormControls } from '@web/shared/components/web-widget-position-settings/type';
import type { WidgetExtendedPositionFormControls } from '@web/shared/components/web-widget-extended-position-settings/type';
import type { EPositionOptions } from '@common/constants/background-position-options.const';
import type { AdvancedBorderSettings } from '@libs/components/sp-advanced-border-settings/type/advanced-border-settings.type';
import type { ShadowSettings } from '@common/types/shadow-settings.type';

export enum EResizeType {
    scale = 'scale',
    fill = 'fill',
}

export type ImageWidgetForm = {
    id: FormControl<string>;
    type?: FormControl<'zero'>;
    name: FormControl<Widgets.IMAGE>;
    data: FormGroup<DefaultImageWidgetDataFormControls> | FormGroup<ZeroImageWidgetDataFormControls>;
    styles: FormGroup<ImageWidgetStyleFormControls>;
    columnId: FormControl<string>;
    displayId?: FormControl<string>;
};

export type ImageWidgetStyleFormControls = {
    borderRadius: FormControl<number>;
    borderTopLeftRadius: FormControl<number>;
    borderTopRightRadius: FormControl<number>;
    borderBottomRightRadius: FormControl<number>;
    borderBottomLeftRadius: FormControl<number>;
    maxWidth: FormControl<number>;
    borderWidth: FormControl<number>;
    borderStyle: FormControl<ELineStyle>;
    borderColor: FormControl<string>;
    advancedBorderSettings: FormControl<AdvancedBorderSettings | null>;
};

export type DefaultImageWidgetDataFormControls = {
    image: FormControl<SelectedFileExtended | null>;
    horizontalAlign: FormControl<EHorizontalPosition>;
    mobileHorizontalAlign: FormControl<EHorizontalPosition>;
    tabletHorizontalAlign: FormControl<EHorizontalPosition>;
    isBorder: FormControl<boolean>;
    isIndependentCorners: FormControl<boolean>;
    resizeType: FormControl<EResizeType>;
    isSynchronizeStyle: FormControl<boolean>;
    hideOnDesktop: FormControl<boolean>;
    hideOnTablet: FormControl<boolean>;
    hideOnMobile: FormControl<boolean>;
    animation: FormGroup<AnimationSettingsFormControls>;
    position: FormGroup<WidgetPositionFormControls>;
    isShadow: FormControl<boolean>;
    shadowSettings: FormControl<ShadowSettings>;
};

export type ZeroImageWidgetDataFormControls = {
    image: FormControl<SelectedFileExtended | null>;
    horizontalAlign: FormControl<EHorizontalPosition>;
    mobileHorizontalAlign: FormControl<EHorizontalPosition>;
    tabletHorizontalAlign: FormControl<EHorizontalPosition>;
    isBorder: FormControl<boolean>;
    isIndependentCorners: FormControl<boolean>;
    resizeType: FormControl<EResizeType>;
    isSynchronizeStyle: FormControl<boolean>;
    hideOnDesktop: FormControl<boolean>;
    hideOnTablet: FormControl<boolean>;
    hideOnMobile: FormControl<boolean>;
    animation: FormGroup<AnimationSettingsFormControls>;
    position: FormGroup<WidgetExtendedPositionFormControls>;
    imagePosition: FormControl<EPositionOptions>;
    isShadow: FormControl<boolean>;
    shadowSettings: FormControl<ShadowSettings>;
};

export type ImageWidgetFormGroup = FormGroup<ImageWidgetForm>;
export type ImageWidgetFormValue = NonNullable<ImageWidgetFormGroup>['value'];
